import type { ProductConfig } from '#types/config/components/product'

export default {
  brandClasses: {
    original: 'c-grey-20',
    sale: 'c-red-30'
  },
  showDiscountedRanges: true
} satisfies ProductConfig['pricing']
